import ModelBase from "./shared/model-base.js";

interface ModelAttributes {
  id: string | number;
  email?: string;
  name?: string;
}

const OPTIONS = {
  i18nModelName: "admin",
  columns: ["id", "email", "name", "created_at"],
  editColumns: {},
};

export default class Admin extends ModelBase {
  constructor(attributes: Partial<ModelAttributes> = {}) {
    super(OPTIONS, attributes);
  }
}
